import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRouter from "./routes/AppRouter";
import reportWebVitals from "./reportWebVitals";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./microsoft/authConfig";

import { HeroUIProvider } from "@heroui/react";

import { Provider } from "react-redux";
import { store } from "./provider/app/store";

// Crear instancia de MSAL
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Inicializar MSAL antes de renderizar
msalInstance
  .initialize()
  .then(async () => {
    // Procesa la respuesta si vienes de un loginRedirect
    const response = await msalInstance.handleRedirectPromise();
    if (response && response.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      // Si ya hay cuentas, tomar la primera como activa
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

    // Ahora sí, renderizamos la app
    root.render(
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <HeroUIProvider>
            <AppRouter />
          </HeroUIProvider>
        </MsalProvider>
      </Provider>
    );
  })
  .catch((error) => {
    console.error("Error inicializando MSAL:", error);
  });

// Opcional: métricas de rendimiento
reportWebVitals();
